import { createSlotRecipe } from './runtime';

const toastConfig = {"name":"toast","slots":["region","root","rule","icon","message","close"],"defaultVariants":{"tone":"info"},"variantMap":{"tone":["error","info","success"]}}

export const toast = /* @__PURE__ */ createSlotRecipe(toastConfig)